import { BuildRulesetQuery } from '../../../interfaces/Rulesets';
import { extractJsonFieldSql } from '../../extractJsonFieldSql';

export const selectFields_ruleset1_PD_OCCO: string = '*';

export const order_ruleset1_PD_OCCO  = 'label';

const getAttributes = (rawName: string) => ({
    dn: `$.15.${rawName}`,
    kvs: `$.14.${rawName}`,
    kvsls: `$.3460.${rawName}`,
    dpmax: `$.28.${rawName}`,
});

export const buildQuery_ruleset1_PD_OCCO: BuildRulesetQuery = ({
    selectFields,
    rawName,
    filter,
    volumetricFlow,
}): [string, string[]] => {

    const attrs = getAttributes(rawName);
    return [
        `WITH products_filtered as (SELECT
                       cast(ifnull(kvsAttr.value, cast(kvslsAttr.value as float) * 3.6) as float) as kvs,
                       cast(dnAttr.value as float) as DN,
                       cast(dpmaxAttr.value as float) as dpmax,
                       CASE
                           WHEN ${extractJsonFieldSql('attributes', `$.7266.${rawName}`)} like '%"Characterised control valve"%' THEN 4
                           WHEN ${extractJsonFieldSql('attributes', `$.7266.${rawName}`)} like '%"Potable water valve"%' THEN 2.5
                           WHEN ${extractJsonFieldSql('attributes', `$.7266.${rawName}`)} like '%"Butterfly valve"%' THEN 4
                           WHEN ${extractJsonFieldSql('attributes', `$.7266.${rawName}`)} like '%"Globe valve"%' THEN 2.94
                           ELSE 0
                       END as maxVelocity,
                       product.id,
                       label,
                       attributes
                    FROM product
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.kvs}`)}) as kvsAttr
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.kvsls}`)}) as kvslsAttr
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.dn}`)}) as dnAttr
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.dpmax}`)}) as dpmaxAttr
                    WHERE ${filter})
            , bounds as (SELECT cast(? as float) as v100)
            , data as (SELECT 
                           3 as rank,
                           id,
                           label,
                           attributes
                       FROM products_filtered
                       JOIN bounds
                       WHERE CASE WHEN dpmax > 0 THEN 
                                100 * pow(bounds.v100 / products_filtered.kvs, 2) <= dpmax
                             ELSE true END  
                             AND CASE WHEN DN > 0 AND bounds.v100 > 0 AND products_filtered.maxVelocity > 0 THEN 
                                bounds.v100 / (3600 * pi() * pow(DN / 1000 / 2, 2)) <= products_filtered.maxVelocity
                             ELSE true END
                       ORDER BY label)
         SELECT ${selectFields}
         FROM data
        `,
        [volumetricFlow]
    ];
}



